exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.banner-changer[data-v-0d6feb02]::after {\n  background: #000;\n  opacity: 0.6;\n  content: '';\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  left: 0;\n  top: 0;\n  border-radius: 0.25rem;\n}\n.contributor-badge-cw[data-v-0d6feb02]::before {\n  top: -20px;\n  left: -20px;\n  right: -20px;\n  bottom: -20px;\n  border-radius: 100%;\n  border: 10px solid transparent;\n}\n", ""]);

// exports
